<template>
    <div class="tab">
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'Tab',
        props: {
            title: {
                type: String,
                default: 'Tab',
                required: false,
            },
        },
        data() {
            return {
                chartInstance: null,
            };
        },
    };
</script>
